module.exports = __webpack_public_path__ + "static/media/fiona_headshot.6e899c1f.jpg";